export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14511.a79f853c.jpg";